import lazysizes from "lazysizes";

export default class lazyloader {
  constructor(element) {
    let self = this;
  }
}
